import { partnerOne } from "data/partnerSection";
import React, { useState } from "react";
import { Col, Image, Row } from "react-bootstrap";
import { useAppStore } from "lib/store";
import { Box, CircularProgress } from '@mui/material';

const PartnerOne = () => {
  const { loading, error, partners } = useAppStore();

  const [isLoading, setIsLoading] = useState(true);

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  return (
    <section className="partner-one">
      <div className="auto-container">
        <div className="sec-title centered">
          <h2>
            Our Suppliers & Partners
            <span className="dot">.</span>
          </h2>
        </div>
        <Row>
          {Array(partners.total).fill(0).slice(1, Array(partners.total).length).map((item, index) => (
            <Col key={`${partners.title}${index}`} md={6} lg={2}>
              <div className="partner-one__card">
                <div className="partner-one__image">
                  <Image
                    src={`${partners.path}${partners.title}${index}.png`}
                    alt={'Partners'}
                  />
                </div>
                <div className="partner-one__content">
                  {/* <h3 className="partner-one__title">{title}</h3> */}
                  {/* <p className="partner-one__text">{text}</p>
                  <a href="#" className="partner-one__link">
                    Read More
                  </a> */}
                </div>
              </div>
            </Col>
          ))}
        </Row>
        <Row>
          {isLoading && (
            <CircularProgress
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            />
          )}
          <Box
            component={'iframe'}
            src="https://wcs-veeamproducts-bountygroupza.swcontentsyndication.com/VeeamProduct-Homepage-EN"
            onLoad={handleIframeLoad}
            style={{ display: isLoading ? 'none' : 'block', height: '2000px', width: '100%', border: 'none' }}
          >
          </Box>
        </Row>
      </div>
    </section>
  );
};

export default PartnerOne;
